<template>
  <app-left-nav-h>
    <template #top>
      <el-menu>
        <!--  -->
        <!--  -->
        <el-tooltip placement="right" content="Matched Opportunities">
          <router-link to="/opportunities/matched">
            <el-menu-item>
              <i class="el-icon-search"></i>
              <span>Matched</span>
            </el-menu-item>
          </router-link>
        </el-tooltip>
        <!--  -->
        <!--  -->
        <el-tooltip placement="right" content="Active Opportunities">
          <router-link to="/opportunities/active">
            <el-menu-item>
              <i class="el-icon-s-opportunity"></i>
              <span>Active</span>
            </el-menu-item>
          </router-link>
        </el-tooltip>
        <!--  -->
        <!--  -->
        <router-link to="/biddings?status=ongoing">
          <el-menu-item>
            <i class="el-icon-document"></i>
            <span>Bids</span>
          </el-menu-item>
        </router-link>
        <!--  -->
        <!--  -->
      </el-menu>
    </template>
    <!--  -->
    <!-- Bottom Main -->
    <template #bottom>
      <el-menu>
        <!--  -->
        <router-link to="/account/account">
          <el-menu-item index="/account">
            <span>Account</span>
          </el-menu-item>
        </router-link>
        <!--  -->
        <router-link to="/account/profile">
          <el-menu-item index="/account/profile">
            <span>Profile</span>
          </el-menu-item>
        </router-link>
        <!--  -->
      </el-menu>
    </template>
  </app-left-nav-h>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
